<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <b-col
        sm="4"
        md="4"
        lg="4"
        class="auth-bg px-2 p-lg-5"
        style="height: 100%; overflow-y: auto;"
      >
        <slot name="card"></slot>
      </b-col>
      
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
        style="background-color: rgb(233 233 233 / 29%); height: 100%; overflow: hidden;"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            style="height: 90vh;"
            alt="Login V2"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import store from '@/store/index'

import { BRow, BCol, BLink, BImg, BOverlay } from "bootstrap-vue";

import AppLogo from '@core/layouts/components/Logo.vue';
import LoginV2Svg from '@/assets/images/logo/logo.gif'

export default {
  name: "AuthWrapperV2",
  components: {
    BRow, 
    BCol, 
    BImg,
    BLink, 
    AppLogo,
    BOverlay,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      sideImg: LoginV2Svg
    }
  },
  computed: {
    imgUrl() {
      return this.sideImg
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/base/pages/app-general.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>
